import React from 'react';
import banner from '../../assets/images/successfull/mob-banner.png';
import SuccessFooter from '../footer/successfullFooter';
import ios_ps from '../../assets/images/footer/ios_appStore.svg';
import android_ps from '../../assets/images/footer/andriod_playStore.svg';
import {NavLink, Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import metatags from '../static/metatags';
class Successfull extends React.Component {
  constructor(props){
    let queryString = window.location.href
    super(props);
    this.state = {
      redirectFromApp: queryString.includes("redirectfromapp=true")
    }
  }
  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.props.successHeaderHome();
  };

  render() {
    return (
      <>
      <section className="cmx-successfull-page">
        <Helmet>
          <title>{metatags.commonMetatag.title}</title>
          <meta name="description" content={metatags.commonMetatag.description} />
        </Helmet>
        <aside className='head text-center pt-4 pb-4'>
          <h1><span className='txt-top d-block'>Welcome to CMX Passport</span></h1>
        </aside>
        <section className='su-container'>
            <aside className={`mail-wrap text-center ${this.state.redirectFromApp ? "mb-4" : ""}`}>
              <p>
                <span>A confirmation email has been sent to &nbsp;
                  <a className='text-decoration-underline' href={`mailto:${this.props.state.loginAPI != '' ? this.props.state.loginAPI.email:this.props.state.signUpEmailValue}`} title={this.props.state.loginAPI != '' ? this.props.state.loginAPI.email:this.props.state.signUpEmailValue}>
                    {this.props.state.loginAPI != '' ? this.props.state.loginAPI.email:this.props.state.signUpEmailValue}
                  </a>
                </span>
              </p>
            </aside>
            {/* <aside className='showtime-wrap'>
              <aside className='lft-side'>
                <p>See what's playing at a CMX Cinema near you</p>
              </aside>
              <aside className='rgt-side'>
                <aside className='cmx-flex-btn-group text-center py-0 d-inline-block'>
                  <a className='flex-btn' href='javascript:;' title='SHOWTIMES'><span>showtimes</span></a>
                </aside>
              </aside>
            </aside> */}
            {
              this.props.state.redirectfromapp &&
                <aside className='downloadapp-wrap'>
                  <p>Download our Mobile App to use your CMX Passport.</p>
                  <figure className='apps-logo'>
                    <a href="https://apps.apple.com/us/app/cmx-cinemas/id1556073550" target="_blank" title='App Store'><img src={ios_ps} width="100" alt="IOS App Store" className="img-fluid" /></a>
                    <a href="https://play.google.com/store/apps/details?id=com.influx.cinema.cmx" target="_blank" title='Google Play'><img src={android_ps} width="100" alt="Android App Store" className="img-fluid" /></a>
                  </figure>
                </aside>
            }
            <section className='sub-plan-details-blk'>
              <section className='sub-inner'>
                <h6>Your CMX Passport Plan</h6>
                <aside className='sub-list'>
                  <ul>
                    <li>
                      <p><span className='title'>Where</span><span className='details'>{this.props.state.step1_content}</span></p>
                    </li>
                    {
                      this.props.state.billingGetPriceObj != '' &&
                      <>
                      <li>
                        <p><span className='title'>When</span><span className='details'>{this.props.state.billingGetPriceObj[0].monThu ? 'Monday to Thursday':'Any day of the year'} {this.props.state.billingGetPriceObj[0].monThu && <i>(Thursdays before 6 pm)</i>}</span></p>
                      </li>
                      <li>
                        <p><span className='title'>How often</span><span className='details'>{this.props.state.billingGetPriceObj[0].visits} Movies(s) Per Month</span></p>
                      </li>
                      <li>
                        <p>
                          <span className='title'>With whom</span>
                          <span className='details'>{this.props.state.billingGetPriceObj[0].guests == '0' ? 'Myself only':`Myself + ${this.props.state.billingGetPriceObj[0].guests} guest(s)`}</span>
                        </p>
                      </li>
                      {/* <li>
                        <p><span className='title'>Subscriber Ticket(s)</span><span className='details text-capitalize'>{this.props.successfullPage_numberToTextConvet(this.props.state.billingGetPriceObj[0].visits)} Per Month</span></p>
                      </li>
                      {
                        this.props.state.billingGetPriceObj[0].guests != '0' &&
                        <li>
                          <p>
                            <span className='title'>Guest Ticket(s)</span>
                            <span className='details text-capitalize'>{this.props.successfullPage_numberToTextConvet((this.props.state.billingGetPriceObj[0].visits)*(this.props.state.billingGetPriceObj[0].guests))} Per Month</span>
                          </p>
                        </li>
                      } */}
                      
                      <li>
                        <p><span className='title'>Billing Cycle</span><span className='details text-capitalize'>{this.props.state.choosePlanName}</span></p>
                      </li>
                      </>
                    }

                  </ul>
                </aside>
              </section>
              <section className='discount-wrap'>
                {/* <p>Enjoy a 10% discount on Food and Beverages when you apply your CMX Rewards Membership to any purchase.<sup>1</sup><br></br><span><sup>1</sup> - excludes alcohol</span></p> */}
                <p>We’re waiving the convenience and blockbuster fees plus you’ll be able to watch 3D, PLF, and Dolby ATMOS at no additional cost.<sup>1</sup></p>
                <p>Save 10% on all Food and Beverage Purchases for you and your guests<sup>2</sup></p>
              </section>
              <section className='note'>
                <p><sup>1</sup> Excludes IMAX and DBOX formats. No fees apply to Passport Credits only. Other fees apply to full-priced tickets.</p>
                <p><sup>2</sup> Excludes alcoholic beverages</p>
                <p>Four month minimum commitment before you can cancel.</p>
              </section>
            </section>
            <section className='su-btm-wrap text-center'>
              <p className='sub'>Learn how to use your CMX Passport <Link className='text-decoration-underline' exact to={"/user-guide"} title='Click here'>Click here</Link></p>
              {/* <p className='wallet'><span>You now have your tickets in your virtual wallet to use</span></p> */}
            </section>
        </section>
      </section>
      {/* <SuccessFooter/> */}
      </>
    )
  }
}

export default Successfull;
